const sendExtensionEvent = (msg: string, data?: {}) =>
  IS_CLIENT_SIDE && window.GR_EXTENSION_SEND?.(msg, data)

export const enableGoExtension = () => sendExtensionEvent('enable-superhuman-go')
export const extensionNotifyUserSessionChange = () => sendExtensionEvent('changed-user')
